import { getAccessToken } from '@src/modules/security/authHelpers';

/**
 * Creates Authorization header with Bearer token
 * @param options - Options for header creation
 * @param options.throwOnMissing - Whether to throw error if token is missing (default: true)
 * @returns Object containing Authorization header
 * @throws Error if token is missing and throwOnMissing is true
 */
export function createAuthHeaders(
  options: { throwOnMissing?: boolean } = {}
): Record<string, string> {
  const { throwOnMissing = true } = options;
  const token = getAccessToken();

  if (!token && throwOnMissing) {
    throw new Error('認証が必要です');
  }

  return token ? { Authorization: `Bearer ${token}` } : {};
}
